/**
 * WooCommerce Store API cart client.
 */
import { getSettings } from '../config.js';
import { isNonceError } from '../utils/errors.js';

function updateNonceFromResponse(response) {
	const next = response.headers.get('Nonce') || response.headers.get('nonce');
	if (next && window.bcQuickBuySettings) {
		window.bcQuickBuySettings.nonce = next;
	}
}

async function refreshNonce() {
	const settings = getSettings();
	const response = await fetch(`${settings.storeApiUrl}/cart`, {
		method: 'GET',
		credentials: 'same-origin',
		headers: {
			Accept: 'application/json',
			Nonce: settings.nonce || '',
		},
	});
	updateNonceFromResponse(response);
	return response.ok;
}

async function postAddItem(body, retried = false) {
	const settings = getSettings();
	const response = await fetch(`${settings.storeApiUrl}/cart/add-item`, {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Nonce: settings.nonce || '',
		},
		body: JSON.stringify(body),
	});

	updateNonceFromResponse(response);

	let payload = null;
	try {
		payload = await response.json();
	} catch (e) {
		payload = null;
	}

	if (!response.ok) {
		const error = new Error(
			(payload && (payload.message || (payload.data && payload.data.message))) ||
				'Add to basket failed'
		);
		error.status = response.status;
		error.code = (payload && payload.code) || 'add_failed';
		error.payload = payload;

		if (!retried && isNonceError(error)) {
			const refreshed = await refreshNonce();
			if (refreshed) {
				return postAddItem(body, true);
			}
		}

		throw error;
	}

	return payload;
}

export async function addSimpleProduct(productId, quantity = 1) {
	return postAddItem({ id: productId, quantity });
}

export async function addVariation(variationId, attributes, quantity = 1) {
	const variation = Object.entries(attributes || {}).map(([attribute, value]) => ({
		attribute,
		value,
	}));

	return postAddItem({
		id: variationId,
		quantity,
		variation,
	});
}
